import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.components.machinelabels';

export default defineMessages({
    idColumn: {
        id: `${scope}.grid.column.id`,
        defaultMessage: 'Id',
    },
    nameColumn: {
        id: `${scope}.grid.column.name`,
        defaultMessage: 'Name',
    },
    iconColumn: {
        id: `${scope}.grid.column.icon`,
        defaultMessage: 'Icon',
    },
    colorColumnLabel: {
        id: `${scope}.grid.column.colorCode`,
        defaultMessage: 'Color',
    },
    editMachineLabelTitle: {
        id: `${scope}.grid.editMachineLabelTitle`,
        defaultMessage: 'Edit machine label',
    },
    addMachineLabelTitle: {
        id: `${scope}.grid.addMachineLabelTitle`,
        defaultMessage: 'Add machine label',
    },
    deleteMachineLabelTitle: {
        id: `${scope}.grid.deleteMachineLabelTitle`,
        defaultMessage: 'Delete machine label',
    },
    saveButton: {
        id: `${scope}.saveButton`,
        defaultMessage: 'Save',
    },
    nameIsMandatory: {
        id: `${scope}.nameIsMandatory`,
        defaultMessage: 'The label needs to have a name',
    },
    iconIsMandatory: {
        id: `${scope}.iconIsMandatory`,
        defaultMessage: 'The label needs to have an icon',
    },
});